export const isMobile = () => (window.innerWidth < 960)